import { useSidebarStore } from "@/store/sidebarStore";
import { AlignJustify } from "lucide-react";
import type { ReactNode } from "react";

interface SidebarProps {
  children: React.ReactNode;
}

interface SidebarItemProps {
  icon: ReactNode;
  text: string;
  active?: boolean;
  alert?: boolean;
  onClick?: () => void;
}

export default function Sidebar({ children }: SidebarProps) {
  const { expanded, toggleExpanded } = useSidebarStore();
  return (
    <>
      <aside>
        <nav className="h-full flex flex-col bg-white border-r border-gray-200">
          <div className="p-4 pb-2 flex justify-between items-center">
            <div
              className={`overflow-hidden transition-all ${
                expanded ? "w-32" : "w-0"
              }`}
            >
              <h1 className="text-xl font-bold text-gray-900">ElectriCare</h1>
            </div>
            <button onClick={toggleExpanded} className="cursor-pointer p-2 rounded-md hover:bg-indigo-100 transition-colors">
              {/* {expanded ? <AlignJustify /> : <ChevronLast />} */}
              <AlignJustify/>
            </button>
          </div>

          <ul className="flex-1 px-3">{children}</ul>
          
        </nav>
      </aside>
    </>
  );
}

export function SidebarItem({ icon, text, active = false, alert = false, onClick }: SidebarItemProps) {
  const { expanded } = useSidebarStore();
  return (
    <li
      onClick={onClick}
      className={`relative flex items-center py-2 px-3 my-1 font-medium rounded-md cursor-pointer transition-colors group ${
        active
          ? "bg-blue-50 text-blue-700 border-r-2 border-blue-600"
          : "hover:bg-gray-50 text-gray-700"
      }`}
    >
      {icon}
      <span
        className={`overflow-hidden transition-all ${
          expanded ? "w-52 ml-3" : "w-0"
        }`}
      >
        {text}
      </span>
      {alert && (
        <div
          className={`absolute right-2 w-2 h-2 rounded bg-indigo-400 ${
            expanded ? "" : "top-2"
          }`}
        ></div>
      )}

      {!expanded && (
        <div
          className={`absolute left-full top-1/2 -translate-y-1/2 ml-2 px-3 py-1 rounded-md bg-black shadow-lg border text-white text-sm z-50 whitespace-nowrap opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition-all duration-150`}
        >
          {text}
        </div>
      )}
    </li>
  );
}
